module.exports = __webpack_public_path__ + "static/media/t-centralen-liggande.6cae008e.jpeg";